import { CTAButtonPosition } from '../schemas';
import type { CTAButtonPosition as ButtonPosition } from '../schemas';

export const getButtonPositionStyle = (buttonPosition: ButtonPosition) => {
  if (buttonPosition === CTAButtonPosition.Enum.left) {
    return 'text-left';
  }

  if (buttonPosition === CTAButtonPosition.Enum.right) {
    return 'text-right';
  }

  return 'text-center';
};
